export default __webpack_public_path__ + "static/media/ravi.32e54af6.png";